/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { useCallback } from "react";
import { TDialogComponent } from "../../../dialogs/Dialog";
import { CodeEditor } from "@adapptio/lib-editor-ui";
import {
	DIALOG_CONTENT_ALIGN,
	DIALOG_CONTENT_FLOW,
	DialogContent
} from "../../../ui/components/Dialogs/DialogContent";
import { DialogHeader } from "../../../ui/components/Dialogs/DialogHeader";
import { DIALOG_SIZE, DialogPanel } from "../../../ui/components/Dialogs/DialogPanel";
import { CodeViewDialog } from "./CodeViewDialog";

export const CodeViewDialogComponent: TDialogComponent<CodeViewDialog> = ({ dialog }) => {
	const baseClass = BEM("edt-module-debug-code-view-dialog");

	const handleClose = useCallback(() => {
		dialog.close();
	}, [ dialog ]);

	return (
		<DialogPanel size={DIALOG_SIZE.MEDIUM} className={baseClass.toClassName()}>
			<DialogHeader title="Code View" icon="mdi/plus" onClose={handleClose} />
			<DialogContent flow={DIALOG_CONTENT_FLOW.COLUMN} align={DIALOG_CONTENT_ALIGN.STRETCH}>
				<CodeEditor language={dialog.language} value={dialog.codeSource} readOnly={true} />
			</DialogContent>
		</DialogPanel>
	);
};
